<div
  class="message-container"
  [class.incoming]="incoming"
  (mouseenter)="onSpeechBubbleEnter()"
  (mouseleave)="onSpeechBubbleLeave($event)"
  (click)="onMessageClick()"
  closeOnEscape
  [isOpen]="isMoreMenuOpen || showEmojiPicker"
  (close)="onEscapePressed()"
  appEmojiPickerCloseOnOutsideHoverDirective
  [isPickerOpen]="showEmojiPicker"
>
  <div
    class="message-content"
    closeOnOutsideClick
    [isOpen]="isMobile && showMiniActions"
    (close)="onCloseMiniActions()"
  >
    <div class="message-header">
      <span class="timestamp">{{ time }}</span>
      @if (isEdited && !isDeleted) {
      <span class="edited">Bearbeitet</span>
      }
      <span class="user-name" (click)="onUserNameClick($event)">{{ displayName }}</span>
    </div>

    <div
      class="speech-bubble"
      [class.msg-box]="isEditing"
      [class.editing]="isEditing"
      [class.deleted]="isDeleted"
    >
      @if (!isEditing && !isDeleted) {
      <app-message-mini-actions
        [visible]="showMiniActions"
        [isMoreMenuOpen]="isMoreMenuOpen"
        [isThreadView]="isThreadView"
        [isDeleted]="isDeleted"
        [isMobile]="isMobile"
        [chatId]="chatId"
        [messageId]="messageId"
        [collectionName]="collectionName"
        [currentUserId]="currentUserId"
        [recentEmojis]="currentUserRecentEmojis"
        (quickReact)="onQuickReact($event)"
        (addReaction)="onMiniAddReactionClick()"
        (openThread)="onOpenThread($event)"
        (visibilityChange)="onMiniActionsVisibilityChange($event)"
        (closeMoreMenu)="onMiniActionsCloseMenu()"
      >
        @if (!incoming) {
        <div
          class="more-menu"
          more-menu
          (click)="$event.stopPropagation()"
          closeOnOutsideClick
          [isOpen]="isMoreMenuOpen"
          (close)="onCloseMoreMenu()"
        >
          <button
            class="mini-icon-btn"
            (click)="toggleMoreMenu($event)"
            aria-label="Weitere Aktionen"
          >
            <svg
              class="mini-icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              focusable="false"
              aria-hidden="true"
            >
              <circle cx="12" cy="5" r="1.8" fill="#4B5563"></circle>
              <circle cx="12" cy="12" r="1.8" fill="#4B5563"></circle>
              <circle cx="12" cy="19" r="1.8" fill="#4B5563"></circle>
            </svg>
          </button>
          @if (isMoreMenuOpen) {
          <div class="menu-dropdown" role="menu">
            <button class="menu-item" role="menuitem" (click)="onEditMessage()">
              Nachricht bearbeiten
            </button>
            <button
              class="menu-item"
              role="menuitem"
              (click)="openConfirmDelete()"
              [disabled]="isDeleting"
            >
              Nachricht löschen
            </button>
          </div>
          }
        </div>
        }
      </app-message-mini-actions>
      } @if (isEditing) {
      <app-message-edit-mode
        [text]="text"
        [isSaving]="isSaving"
        [isDeleting]="isDeleting"
        (save)="saveEdit($event)"
        (cancel)="cancelEdit()"
      ></app-message-edit-mode>
      } @else {
      <p>{{ text }}</p>
      }
    </div>

    @if (!isEditing) {
    <app-message-thread-summary
      [chatId]="chatId"
      [messageId]="messageId"
      [collectionName]="collectionName"
      (openThread)="onCommentClick()"
      >></app-message-thread-summary
    >
    <app-message-reactions
      [reactions]="reactions"
      [isNarrow]="isNarrow"
      [isVeryNarrow]="isVeryNarrow"
      [isMobile]="isMobile"
      [maxReactions]="9999"
      [isDeleted]="isDeleted"
      [showEmojiPicker]="showEmojiPicker"
      [defaultCollapseThreshold]="20"
      [narrowCollapseThreshold]="7"
      [veryNarrowCollapseThreshold]="7"
      (reactionClick)="onReactionClick($event)"
      (emojiSelected)="onReactionsEmojiSelected($event)"
      (toggleEmojiPicker)="onReactionsToggleEmojiPicker()"
      (closeEmojiPicker)="onReactionsCloseEmojiPicker()"
    ></app-message-reactions>
    }
  </div>
  <div class="avatar-container">
    <img [src]="avatar" alt="User Avatar" class="avatar-img" />
  </div>
</div>
